import { Cpu, Radio, DoorClosed, Droplets, Flame, Bell, Camera, Smartphone } from "lucide-react";

const services = [
  { icon: Cpu, badge: "Zentrale", title: "Alarm-Zentrale", desc: "Die intelligente Basisstation – vernetzt alle Sensoren, LTE-Backup, sofortige Alarmierung." },
  { icon: Radio, badge: "Bewegung", title: "Bewegungsmelder", desc: "Präzise Erkennung ohne Fehlalarme durch Haustiere. Weitwinkel, funkbasiert." },
  { icon: DoorClosed, badge: "Zugang", title: "Tür- & Fensterkontakte", desc: "Magnetkontakte für alle Öffnungspunkte – dezent, spurlos, extrem langlebig." },
  { icon: Droplets, badge: "Wasser", title: "Wassermelder", desc: "Frühwarnung bei Leckagen unter Waschmaschine, Spüle oder Heizungsraum." },
  { icon: Flame, badge: "Brand", title: "Rauch- & Wärmemelder", desc: "Vernetzte Melder mit App-Alarm – erkennt Rauch und ungewöhnliche Wärmeentwicklung." },
  { icon: Bell, badge: "Abschreckung", title: "Innen- & Außensirene", desc: "Optische und akustische Alarmierung. Schreckt Eindringlinge sofort ab." },
  { icon: Camera, badge: "Optional", title: "IP-Kamera", desc: "Live-Bild, Nachtsicht und Bewegungsauslösung – nur bei Bedarf." },
  { icon: Smartphone, badge: "Steuerung", title: "Sicherheits-App", desc: "Push-Alarme, Historie, Szenarien und Live-Status – iOS & Android." },
];

export const ServicesSection = () => {
  return (
    <section id="services" data-testid="services-section" className="ss-section bg-white">
      <div className="ss-container">
        <div className="max-w-3xl">
          <span className="ss-eyebrow">System &amp; Komponenten</span>
          <h2 className="ss-h2 mt-4 text-slate-900">Was in Ihrer Immobilie installiert wird.</h2>
          <p className="ss-lead mt-4">
            Wir setzen auf <strong>zertifizierte Premium-Sicherheitstechnik</strong> – eine der meistausgezeichneten Funk-Alarmtechnologien Europas. Ein durchdachtes, spurloses System, das im Verkauf sofort überzeugt.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="services-grid">
          {services.map((s, i) => (
            <article
              key={s.title}
              className="ss-card group"
              data-testid={`service-card-${i}`}
            >
              <div className="flex items-center justify-between">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-slate-50 text-[#071A2B] border border-slate-200 group-hover:bg-[var(--ss-gold)]/10 group-hover:text-[#EAB308] transition-colors">
                  <s.icon className="h-5 w-5" strokeWidth={2.2} />
                </span>
                <span className="text-[10px] font-semibold uppercase tracking-widest text-slate-500">
                  {s.badge}
                </span>
              </div>
              <h3 className="font-display font-semibold text-lg text-slate-900 mt-5">{s.title}</h3>
              <p className="text-sm text-slate-600 mt-2 leading-relaxed">{s.desc}</p>
            </article>
          ))}
        </div>

        {/* System-showcase strip */}
        <div className="mt-14 rounded-2xl overflow-hidden border border-slate-200 grid md:grid-cols-2">
          <div className="relative min-h-[280px] bg-slate-100">
            <img
              src="https://images.unsplash.com/photo-1655388333786-6b8270e2e154?w=1200&q=85&auto=format&fit=crop"
              alt="Smart-Home App zur Steuerung der Alarmanlage – SecurityStaging.de"
              className="absolute inset-0 h-full w-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="p-8 sm:p-10 flex flex-col justify-center bg-slate-50">
            <span className="ss-eyebrow">Alles per App</span>
            <h3 className="ss-h3 mt-3 text-slate-900">Volle Kontrolle – für Eigentümer, Makler und späteren Käufer.</h3>
            <p className="mt-3 text-slate-600">
              Sicherheits-App auf dem Smartphone: Live-Status, Push-Benachrichtigungen, Historie und Zugriffsrechte je Nutzer. Die Anlage lässt sich vor Ort scharf/unscharf schalten – oder aus der Ferne, weltweit.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
